import { fromJS } from 'immutable';
import {
  ROUTE_COURSE_ADMIN,
  ROUTE_COHORT_ADMIN,
  ROUTE_COURSE_ASSESSMENT,
  ROUTE_COURSE_CERTIFICATION,
} from '../routeActions';
import {
  COURSE_NAVIGATION_DATA_SET,
  COURSE_NAVIGATION_SET_COURSE_ADMIN,
  COURSE_NAVIGATION_SET_COHORT_ADMIN,
  COURSE_NAVIGATION_SET_CERTIFICATION,
  COURSE_NAVIGATION_SET_ASSESSMENT,
  COURSE_NAVIGATION_LOAD_START,
  COURSE_NAVIGATION_LOAD_FAIL,
} from './actions';

export function CourseNavigationInfo(
  state = fromJS({ byCoursePath: {} }),
  action
) {
  switch (action.type) {
    case COURSE_NAVIGATION_DATA_SET: {
      const { coursePath, navigation } = action;
      return state
        .mergeIn(['byCoursePath'], fromJS(navigation))
        .setIn(['byCoursePath', coursePath, 'isLoadingNavData'], false)
        .setIn(['byCoursePath', coursePath, 'hasLoadedNavData'], true);
    }
    case ROUTE_COURSE_ADMIN:
    case COURSE_NAVIGATION_SET_COURSE_ADMIN:
      return state.set(
        'courseAdminExpanded',
        action.expanded !== undefined ? action.expanded : true
      );
    case ROUTE_COHORT_ADMIN:
    case COURSE_NAVIGATION_SET_COHORT_ADMIN:
      return state.set(
        'cohortAdminExpanded',
        action.expanded !== undefined ? action.expanded : true
      );
    case ROUTE_COURSE_CERTIFICATION:
    case COURSE_NAVIGATION_SET_CERTIFICATION:
      return state.set(
        'certificationExpanded',
        action.expanded !== undefined ? action.expanded : true
      );
    case ROUTE_COURSE_ASSESSMENT:
    case COURSE_NAVIGATION_SET_ASSESSMENT:
      return state.set(
        'assessmentExpanded',
        action.expanded !== undefined ? action.expanded : true
      );
    case COURSE_NAVIGATION_LOAD_START:
      return state.setIn(
        ['byCoursePath', action.coursePath, 'isLoadingNavData'],
        true
      );
    case COURSE_NAVIGATION_LOAD_FAIL:
      return state.setIn(
        ['byCoursePath', action.coursePath, 'isLoadingNavData'],
        false
      );
    default: {
      return state;
    }
  }
}
